import { defineMessages } from 'react-intl';

export const jurisdictionSelectMessages = defineMessages({
  selectStateRegion: {
    defaultMessage: 'Select state / region',
    id: '9iRogKghOl',
    description:
      'Default placeholder for jurisdiction select when no subdivision label is provided',
  },
  searchStateRegion: {
    defaultMessage: 'Search state / region',
    id: 'fNdLB5i1C5',
    description:
      'Default search placeholder for jurisdiction select when no subdivision label is provided',
  },
  selectSubdivision: {
    defaultMessage: 'Select {label}',
    id: '0jpMFMOROw',
    description:
      'Placeholder for jurisdiction select with a known subdivision type (e.g. "Select state", "Select province")',
  },
  searchSubdivision: {
    defaultMessage: 'Search {label}',
    id: 'as+CRiaVbL',
    description:
      'Search placeholder for jurisdiction select with a known subdivision type (e.g. "Search state", "Search province")',
  },
  selectCountryFirst: {
    defaultMessage: 'Set country in settings first',
    id: '8NFOOmvt2u',
    description:
      'Disabled placeholder on jurisdiction select when no country is selected yet',
  },
  noRegionsAvailable: {
    defaultMessage: 'No states/regions available',
    id: 'i72DOWZ8lc',
    description:
      'Disabled placeholder on jurisdiction select when the country has no subdivisions',
  },
  noResultsFound: {
    defaultMessage: 'No results found',
    id: 'LcI3Ban+Pl',
    description: 'Empty state when jurisdiction search returns no matches',
  },
});
